import { Navigate } from 'react-router-dom';

const Root = () => {
    const getRootUrl = () => 'gestao/cursos';

    const url = getRootUrl();

    return <Navigate to={`/${url}`} />;
};

export default Root;
